import { render, staticRenderFns } from "./ContactAddress.vue?vue&type=template&id=bbaf6052"
import script from "./ContactAddress.vue?vue&type=script&lang=js"
export * from "./ContactAddress.vue?vue&type=script&lang=js"
import style0 from "./ContactAddress.vue?vue&type=style&index=0&id=bbaf6052&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports